var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selectMap) ? _c('div', {
    staticClass: "scope-arrangement-item"
  }, [(_vm.isSingle) ? _c('el-row', {
    staticClass: "top-handler-wpr"
  }, [_c('el-col', [(this.tableData.length < 4) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": _vm.addInterview
    }
  }, [_vm._v("添加面试\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('arrange-common', {
    on: {
      "sendEmail": _vm.sendEmail
    }
  })], 1)], 1)], 1) : _c('el-row', {
    staticClass: "top-handler-wpr mb-20",
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "name user-name",
    attrs: {
      "span": 19
    }
  }, [_c('thumbnail', {
    attrs: {
      "width": 36,
      "gender": _vm.init.resume.gender === 2 ? 'woman' : 'man',
      "mode": "horizontal"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "color": "#000"
    },
    domProps: {
      "textContent": _vm._s(_vm.init.resume.name)
    }
  })])]), _vm._v(" "), _c('PIcon', {
    staticClass: "dept-name multi-info",
    attrs: {
      "tooltip": "应聘部门",
      "display": "inline-block",
      "icon": "el-icon-my-xiugaibumen"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.init.position.deptNames) + "\n            ")]), _vm._v(" "), _c('PIcon', {
    staticClass: "dept-name multi-info",
    attrs: {
      "tooltip": "应聘职位",
      "display": "inline-block",
      "icon": "el-icon-my-gongzuojingli"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.init.position.name) + "\n            ")]), _vm._v(" "), _c('PIcon', {
    staticClass: "dept-name multi-info",
    attrs: {
      "tooltip": "联系方式",
      "display": "inline-block",
      "icon": "el-icon-my-shouji"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.init.resume.mobilePhone || '无') + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 5
    }
  }, [(this.tableData.length < 4) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": _vm.addInterview
    }
  }, [_vm._v("添加面试\n            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": true
    },
    on: {
      "click": _vm.removeInterview
    }
  }, [_vm._v("移除")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-10"
  }, [_c('el-table', {
    ref: "table",
    class: {
      'multi': !_vm.isSingle
    },
    attrs: {
      "data": _vm.tableData,
      "row-class-name": "interview-one"
    },
    on: {
      "row-click": _vm.selectedRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面试阶段",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', [_c('el-select', {
          attrs: {
            "size": "medium",
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.turnType),
            callback: function($$v) {
              _vm.$set(scope.row, "turnType", $$v)
            },
            expression: "scope.row.turnType"
          }
        }, _vm._l((_vm.turnOptions), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1) : [_c('span', [_vm._v(_vm._s(_vm.turnMap[scope.row.turn]) + "\n                        "), (~~scope.row.isHr) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("HR面")]) : _vm._e()], 1)]]
      }
    }], null, false, 1957778102)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面试时间",
      "align": "center",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', [_c('el-date-picker', {
          staticClass: "el-input--noprefix",
          attrs: {
            "size": "medium",
            "prefix-icon": " ",
            "format": "yyyy-MM-dd HH:mm",
            "type": "datetime",
            "placeholder": "选择日期时间"
          },
          model: {
            value: (scope.row.interviewDate),
            callback: function($$v) {
              _vm.$set(scope.row, "interviewDate", $$v)
            },
            expression: "scope.row.interviewDate"
          }
        })], 1) : _c('div', [_c('span', {
          staticClass: "ml-5"
        }, [_vm._v(_vm._s(_vm.dateFormat(scope.row.interviewDate)))])])]
      }
    }], null, false, 1027157844)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面试形式",
      "align": "center",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', [_c('el-select', {
          attrs: {
            "size": "medium",
            "value": scope.row.interviewType,
            "placeholder": "请选择"
          },
          on: {
            "input": function($event) {
              return _vm.handleChangeInterviewType($event, scope.$index)
            }
          }
        }, _vm._l((_vm.selectMap.WB_INTERVIEW_TYPE), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.getSelectMapText('WB_INTERVIEW_TYPE', scope.row.interviewType)))])])]
      }
    }], null, false, 4164630613)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面试官",
      "align": "center",
      "min-width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', [_c('user-search', {
          ref: ("masterInterviewer" + (scope.$index)),
          staticStyle: {
            "width": "95%",
            "display": "inline-block"
          },
          attrs: {
            "index": scope.$index,
            "holder": "面试官"
          },
          model: {
            value: (scope.row.masterInterviewer),
            callback: function($$v) {
              _vm.$set(scope.row, "masterInterviewer", $$v)
            },
            expression: "scope.row.masterInterviewer"
          }
        }), _vm._v(" "), _c('user-search', {
          ref: "interviewer",
          staticStyle: {
            "width": "50%",
            "display": "none"
          },
          attrs: {
            "index": scope.$index,
            "holder": "副面试官"
          },
          model: {
            value: (scope.row.interviewer),
            callback: function($$v) {
              _vm.$set(scope.row, "interviewer", $$v)
            },
            expression: "scope.row.interviewer"
          }
        })], 1) : [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('span', [_c('span', {
          staticClass: "mr-15"
        }, [_vm._v(_vm._s(scope.row.masterInterviewerNames))])])])]]
      }
    }], null, false, 1679468098)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面试地点",
      "align": "center",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', {
          staticClass: "text-ellipsis"
        }, [_c('el-input', {
          attrs: {
            "size": "medium",
            "placeholder": "请输入内容"
          },
          model: {
            value: (scope.row.interviewPlace),
            callback: function($$v) {
              _vm.$set(scope.row, "interviewPlace", $$v)
            },
            expression: "scope.row.interviewPlace"
          }
        })], 1) : _c('div', {
          staticClass: "text-ellipsis"
        }, [_c('span', [_vm._v(_vm._s(scope.row.interviewPlace))])])]
      }
    }], null, false, 605741618)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "会议链接",
      "align": "center",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', {
          staticClass: "text-ellipsis"
        }, [(scope.row.interviewType === '5') ? _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#c4c4c4"
          }
        }, [_vm._v("安排后自动生成")]) : _c('el-input', {
          attrs: {
            "size": "medium",
            "placeholder": "请输入",
            "maxlength": "1000"
          },
          model: {
            value: (scope.row.conferenceLinks),
            callback: function($$v) {
              _vm.$set(scope.row, "conferenceLinks", $$v)
            },
            expression: "scope.row.conferenceLinks"
          }
        })], 1) : _c('div', {
          staticClass: "text-ellipsis"
        }, [(scope.row.interviewType === '5') ? _c('a', {
          attrs: {
            "href": scope.row.conferenceLinks,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(scope.row.conferenceLinks))]) : _c('span', [_vm._v(_vm._s(scope.row.conferenceLinks || ''))])])]
      }
    }], null, false, 364412834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.onSubmit(scope.row, scope.$index)
            }
          }
        }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.toggleEdit(scope.row, scope.$index)
            }
          }
        }, [_c('span', {
          staticClass: "color-danger"
        }, [_vm._v("取消")])])], 1) : _c('div', [(scope.row.id) ? _c('el-button', {
          staticClass: "hide",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showVisitorFlow(scope.row)
            }
          }
        }, [_vm._v("发起访客申请\n                        ")]) : _vm._e(), _vm._v(" "), (scope.row.id && scope.row.hasEvl !== true) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.toggleEdit(scope.row, scope.$index)
            }
          }
        }, [_vm._v("编辑\n                        ")]) : _vm._e(), _vm._v(" "), (scope.row.id && scope.row.hasEvl !== true) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.removeRow(scope.row, scope.$index)
            }
          }
        }, [_c('span', {
          staticClass: "color-danger"
        }, [_vm._v("删除")])]) : _vm._e(), _vm._v(" "), (scope.row.hasEvl) ? _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#c4c4c4"
          }
        }, [_vm._v("已评价不可操作")]) : _vm._e()], 1)]
      }
    }], null, false, 88713239)
  })], 1)], 1), _vm._v(" "), _c('visitor-flow-handler', {
    ref: "visitorFlow"
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e1c0c2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/arrangement/arrangementItem.vue
// module id = null
// module chunks = 